module.exports = __webpack_public_path__ + "static/assets/e1871903e042f246748298a915bee971.png";